import { render, staticRenderFns } from "./account-plan-loader.vue?vue&type=template&id=72cae451"
import script from "./account-plan-loader.vue?vue&type=script&lang=ts"
export * from "./account-plan-loader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports